// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "rescript-classnames/src/Cn.bs.js";
import * as BsCss from "../../bindings/BsCss.bs.js";
import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as Theme from "../../css/Theme.bs.js";
import * as React from "react";
import Link from "next/link";
import * as Belt_Option from "@rescript/std/lib/es6/belt_Option.js";
import * as JsxRuntime from "react/jsx-runtime";

var container = Curry._1(BsCss.style, {
      hd: BsCss.lineHeight(BsCss.rem(1.25)),
      tl: {
        hd: BsCss.color(Theme.Color.midGrey),
        tl: {
          hd: BsCss.paddingTop(BsCss.rem(0.625)),
          tl: {
            hd: BsCss.paddingBottom(BsCss.rem(0.625)),
            tl: {
              hd: BsCss.paddingLeft(BsCss.rem(1.0)),
              tl: {
                hd: BsCss.paddingRight(BsCss.rem(1.0)),
                tl: {
                  hd: BsCss.media("(max-width: 380px)", {
                        hd: BsCss.paddingLeft(BsCss.rem(0.8)),
                        tl: {
                          hd: BsCss.paddingRight(BsCss.rem(0.8)),
                          tl: /* [] */0
                        }
                      }),
                  tl: {
                    hd: BsCss.border(BsCss.px(1), "solid", Theme.Color.lightGrey),
                    tl: {
                      hd: BsCss.selector("+ li", {
                            hd: BsCss.unsafe("borderLeft", "0px"),
                            tl: /* [] */0
                          }),
                      tl: /* [] */0
                    }
                  }
                }
              }
            }
          }
        }
      }
    });

var first = Curry._1(BsCss.style, {
      hd: BsCss.borderTopLeftRadius(BsCss.px(10)),
      tl: {
        hd: BsCss.borderBottomLeftRadius(BsCss.px(10)),
        tl: /* [] */0
      }
    });

var last = Curry._1(BsCss.style, {
      hd: BsCss.borderTopRightRadius(BsCss.px(10)),
      tl: {
        hd: BsCss.borderBottomRightRadius(BsCss.px(10)),
        tl: /* [] */0
      }
    });

var disabled = Curry._1(BsCss.style, {
      hd: BsCss.important(BsCss.color(Theme.Color.lightGrey)),
      tl: {
        hd: BsCss.cursor("auto"),
        tl: /* [] */0
      }
    });

var selected = Curry._1(BsCss.style, {
      hd: BsCss.important(BsCss.color(Theme.Color.white)),
      tl: {
        hd: BsCss.backgroundColor(Theme.Color.charcoal),
        tl: /* [] */0
      }
    });

var Styles = {
  container: container,
  first: first,
  last: last,
  disabled: disabled,
  selected: selected
};

var make = React.memo(function (props) {
      var isLast = props.isLast;
      var isFirst = props.isFirst;
      var className = props.className;
      var title = props.title;
      var isDisabled = Belt_Option.getWithDefault(props.disabled, false);
      var isSelected = Belt_Option.getWithDefault(props.selected, false);
      var classNames = React.useMemo((function () {
              return Cn.make([
                          Belt_Option.getWithDefault(className, ""),
                          Belt_Option.getWithDefault(isFirst, false) ? first : "",
                          Belt_Option.getWithDefault(isLast, false) ? last : "",
                          isSelected ? selected : "",
                          container,
                          isDisabled ? disabled : ""
                        ]);
            }), [
            isFirst,
            isDisabled,
            props.large,
            isLast,
            isSelected
          ]);
      return JsxRuntime.jsx("li", {
                  children: isDisabled || isSelected ? JsxRuntime.jsx("a", {
                          children: title,
                          "aria-label": title,
                          "aria-selected": isSelected,
                          disabled: true
                        }) : JsxRuntime.jsx(Link, {
                          href: props.href,
                          prefetch: false,
                          children: JsxRuntime.jsx("a", {
                                children: title,
                                "aria-label": title
                              })
                        }),
                  className: classNames
                });
    });

var Link$1;

export {
  Link$1 as Link,
  Styles ,
  make ,
}
/* container Not a pure module */
